module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hospital_informations/noimage_s500x350-e3311f5413fe8cccb544de450d787520.png";